import { ArrowLeft, Sparkles, XCircle } from "lucide-react";
import { Link } from "react-router-dom";

export const SubscriptionCancelled = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#141419] via-[#0c0c10] to-black text-white flex items-center justify-center p-4 relative overflow-hidden">
    <div
      className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[350px] bg-purple-600/10 blur-[140px] pointer-events-none rounded-full"
      aria-hidden="true"
    />

    <div className="glass-card p-8 sm:p-10 max-w-lg w-full text-center rounded-3xl border border-white/10 shadow-2xl relative z-10 space-y-6">
      <div className="w-16 h-16 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto text-gray-400">
        <XCircle className="w-9 h-9" />
      </div>

      <div className="space-y-2">
        <h1 className="text-2xl sm:text-3xl font-black text-white">
          Checkout Cancelled
        </h1>
        <p className="text-sm text-gray-400 leading-relaxed font-light">
          No charges were made. If you hit your free tier limits or change your
          mind, you can upgrade to Premium anytime.
        </p>
      </div>

      <div className="pt-2 flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/upgrade"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white font-bold text-sm shadow-lg shadow-purple-600/20 transition active:scale-95"
        >
          <Sparkles className="w-4 h-4" />
          <span>Try Again</span>
        </Link>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-2xl bg-white/10 hover:bg-white/15 text-white font-semibold text-sm border border-white/10 transition active:scale-95"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Events</span>
        </Link>
      </div>
    </div>
  </div>
);
